const status = {
  DEFAULT: 'default',
  FETCHING: 'fetching',
  SUCCESS: 'success',
  FAILURE: 'failure'
}

export default status
